var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 128,
    viewBox: "0 0 148 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_310_984",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 1,
    width: 110,
    height: 126
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9766 2.35829C82.4701 0.901339 85.5552 0.901341 88.0486 2.35829L134.814 29.6838C137.269 31.1182 138.778 33.7478 138.778 36.5911V91.4089C138.778 94.2522 137.269 96.8818 134.814 98.3162L88.0486 125.642C85.5552 127.099 82.4701 127.099 79.9766 125.642L33.2114 98.3162C30.7565 96.8818 29.2474 94.2522 29.2474 91.4089V36.5911C29.2474 33.7478 30.7565 31.1182 33.2114 29.6838L79.9766 2.35829Z",
    fill: "#0CAF60"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_310_984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9766 2.35829C82.4701 0.901339 85.5552 0.901341 88.0486 2.35829L134.814 29.6838C137.269 31.1182 138.778 33.7478 138.778 36.5911V91.4089C138.778 94.2522 137.269 96.8818 134.814 98.3162L88.0486 125.642C85.5552 127.099 82.4701 127.099 79.9766 125.642L33.2114 98.3162C30.7565 96.8818 29.2474 94.2522 29.2474 91.4089V36.5911C29.2474 33.7478 30.7565 31.1182 33.2114 29.6838L79.9766 2.35829Z",
    fill: "#3F3F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.264 26.6667H75.369C72.7899 26.6667 70.699 28.7828 70.699 31.393V100.78C70.699 103.39 72.7899 105.506 75.369 105.506H176.264C178.843 105.506 180.934 103.39 180.934 100.78V31.393C180.934 28.7828 178.843 26.6667 176.264 26.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.89 29.3469H78.7773C76.3923 29.3469 74.4588 31.3037 74.4588 33.7175V97.3356C74.4588 99.7494 76.3923 101.706 78.7773 101.706H172.89C175.275 101.706 177.208 99.7494 177.208 97.3356V33.7175C177.208 31.3037 175.275 29.3469 172.89 29.3469Z",
    fill: "#5F5FA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.119 104.763H66.0635C63.7534 104.763 61.8807 106.658 61.8807 108.996V109.454C61.8807 111.792 63.7534 113.687 66.0635 113.687H183.119C185.429 113.687 187.302 111.792 187.302 109.454V108.996C187.302 106.658 185.429 104.763 183.119 104.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.119 104.763H66.0635C63.7534 104.763 61.8807 106.658 61.8807 108.996V109.454C61.8807 111.792 63.7534 113.687 66.0635 113.687H183.119C185.429 113.687 187.302 111.792 187.302 109.454V108.996C187.302 106.658 185.429 104.763 183.119 104.763Z",
    fill: "url(#paint0_linear_310_984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.624 104.844H112.18V107.489H137.624V104.844Z",
    fill: "url(#paint1_linear_310_984)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_310_984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.251 40.3824V80.2223C108.251 81.6152 107.705 82.9513 106.733 83.9377C105.762 84.9241 104.443 85.4802 103.067 85.4843H22.9341C22.2519 85.4843 21.5763 85.3481 20.9462 85.0835C20.316 84.8189 19.7436 84.4311 19.2617 83.9424C18.7798 83.4536 18.3978 82.8734 18.1378 82.2351C17.8777 81.5967 17.7446 80.9127 17.7461 80.2223V40.3824C17.7461 38.9899 18.2927 37.6544 19.2656 36.6697C20.2386 35.685 21.5582 35.1318 22.9341 35.1318H103.067C104.441 35.1349 105.759 35.6891 106.731 36.6733C107.702 37.6574 108.249 38.9912 108.251 40.3824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5918 84.4528L101.401 94.9333V82.1333L85.5918 84.4528Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9222 45.3478C62.6886 45.4328 62.4315 45.4228 62.205 45.32C61.9785 45.2171 61.8003 45.0292 61.7079 44.7961L60.7981 42.3496C60.538 41.6815 60.0285 41.1439 59.3798 40.853C58.7311 40.5622 57.9953 40.5416 57.3316 40.7957C56.668 41.0497 56.1299 41.558 55.8337 42.2105C55.5376 42.8631 55.5072 43.6074 55.7492 44.2824L57.0086 47.6496C57.0288 47.7052 57.0439 47.7625 57.0537 47.8209H55.0612L53.9897 44.9559C53.5842 43.812 53.6389 42.5528 54.1419 41.4493C54.6449 40.3459 55.5561 39.4866 56.6791 39.0565C57.8022 38.6264 59.0472 38.66 60.146 39.15C61.2448 39.64 62.1095 40.5472 62.5537 41.6761L63.4673 44.1188C63.5114 44.2357 63.5323 44.3603 63.5288 44.4854C63.5252 44.6105 63.4974 44.7336 63.4467 44.8478C63.3961 44.9619 63.3237 45.0649 63.2337 45.1507C63.1437 45.2365 63.0378 45.3034 62.9222 45.3478V45.3478Z",
    fill: "#3F3F95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8595 47.8438H53.5098V59.3913H65.8595V47.8438Z",
    fill: "url(#paint2_linear_310_984)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8441 47.8208H58.0996V59.3683H65.8441V47.8208Z",
    fill: "url(#paint3_linear_310_984)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3903 53.2313C59.3903 53.2313 58.1722 52.204 59.2361 51.3289C60.3 50.4538 61.4918 52.2801 60.364 53.2313L61.1572 55.3733H58.4805L59.3903 53.2313Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1371 63.3319H31.8056C30.464 63.3319 29.3785 64.4322 29.3785 65.787V72.5063C29.3785 73.8611 30.464 74.9614 31.8056 74.9614H93.1371C94.4787 74.9614 95.5642 73.8611 95.5642 72.5063V65.787C95.5642 64.4322 94.4787 63.3319 93.1371 63.3319Z",
    fill: "white",
    stroke: "#CBD5E0",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9255 71.2658C40.2273 71.2658 41.2826 70.1978 41.2826 68.8802C41.2826 67.5627 40.2273 66.4946 38.9255 66.4946C37.6236 66.4946 36.5683 67.5627 36.5683 68.8802C36.5683 70.1978 37.6236 71.2658 38.9255 71.2658Z",
    fill: "#5F5FA7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2868 71.2658C46.5886 71.2658 47.644 70.1978 47.644 68.8802C47.644 67.5627 46.5886 66.4946 45.2868 66.4946C43.985 66.4946 42.9296 67.5627 42.9296 68.8802C42.9296 70.1978 43.985 71.2658 45.2868 71.2658Z",
    fill: "#5F5FA7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6423 71.2658C52.9441 71.2658 53.9994 70.1978 53.9994 68.8802C53.9994 67.5627 52.9441 66.4946 51.6423 66.4946C50.3404 66.4946 49.2851 67.5627 49.2851 68.8802C49.2851 70.1978 50.3404 71.2658 51.6423 71.2658Z",
    fill: "#5F5FA7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9977 71.2658C59.2996 71.2658 60.3549 70.1978 60.3549 68.8802C60.3549 67.5627 59.2996 66.4946 57.9977 66.4946C56.6959 66.4946 55.6406 67.5627 55.6406 68.8802C55.6406 70.1978 56.6959 71.2658 57.9977 71.2658Z",
    fill: "#5F5FA7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8591 71.2658C66.1609 71.2658 67.2162 70.1978 67.2162 68.8802C67.2162 67.5627 66.1609 66.4946 64.8591 66.4946C63.5572 66.4946 62.5019 67.5627 62.5019 68.8802C62.5019 70.1978 63.5572 71.2658 64.8591 71.2658Z",
    fill: "#5F5FA7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2126 71.2658C72.5144 71.2658 73.5697 70.1978 73.5697 68.8802C73.5697 67.5627 72.5144 66.4946 71.2126 66.4946C69.9107 66.4946 68.8554 67.5627 68.8554 68.8802C68.8554 70.1978 69.9107 71.2658 71.2126 71.2658Z",
    fill: "#5F5FA7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.568 71.2658C78.8699 71.2658 79.9252 70.1978 79.9252 68.8802C79.9252 67.5627 78.8699 66.4946 77.568 66.4946C76.2662 66.4946 75.2109 67.5627 75.2109 68.8802C75.2109 70.1978 76.2662 71.2658 77.568 71.2658Z",
    fill: "#5F5FA7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9333 71.2658C85.2351 71.2658 86.2904 70.1978 86.2904 68.8802C86.2904 67.5627 85.2351 66.4946 83.9333 66.4946C82.6314 66.4946 81.5761 67.5627 81.5761 68.8802C81.5761 70.1978 82.6314 71.2658 83.9333 71.2658Z",
    fill: "#5F5FA7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9192 31.407C20.5536 31.4068 20.196 31.2987 19.8902 31.096C19.5844 30.8932 19.3436 30.6046 19.1974 30.2655L15.1372 20.7992C15.0384 20.5699 14.9853 20.3231 14.9808 20.073C14.9763 19.8229 15.0205 19.5743 15.1109 19.3415C15.2013 19.1086 15.3362 18.8961 15.5077 18.716C15.6793 18.5359 15.8843 18.3918 16.1109 18.2919C16.3375 18.192 16.5813 18.1382 16.8284 18.1336C17.0756 18.1291 17.3212 18.1738 17.5513 18.2653C17.7813 18.3568 17.9913 18.4933 18.1692 18.6669C18.3472 18.8406 18.4896 19.048 18.5883 19.2773L22.6448 28.7474C22.7697 29.0371 22.8213 29.3538 22.795 29.6688C22.7687 29.9838 22.6652 30.2872 22.4939 30.5515C22.3226 30.8159 22.089 31.0329 21.814 31.1829C21.5391 31.3329 21.2315 31.4112 20.9192 31.4108V31.407Z",
    fill: "#5F5FA7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.69278 44.3852C2.19424 44.4018 1.70959 44.2174 1.34544 43.8724C0.981295 43.5274 0.767476 43.0501 0.751024 42.5456C0.734573 42.041 0.916836 41.5505 1.25772 41.182C1.5986 40.8134 2.07018 40.597 2.56871 40.5804L12.738 39.8917C13.2365 39.8579 13.7279 40.0259 14.1041 40.3588C14.4802 40.6917 14.7103 41.1621 14.7437 41.6666C14.7771 42.1712 14.6111 42.6685 14.2822 43.0492C13.9533 43.4298 13.4884 43.6627 12.9899 43.6965L2.81684 44.3814L2.69278 44.3852Z",
    fill: "#5F5FA7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5094 35.0218C13.1378 35.0206 12.775 34.9066 12.4681 34.6946L4.0206 28.8961C3.61655 28.6091 3.34027 28.1728 3.25141 27.6813C3.16256 27.1899 3.26828 26.6829 3.54573 26.2697C3.82318 25.8565 4.25009 25.5703 4.73426 25.473C5.21843 25.3757 5.721 25.475 6.13341 25.7495L14.5658 31.548C14.8974 31.777 15.1479 32.1074 15.2805 32.4909C15.4131 32.8743 15.4209 33.2907 15.3029 33.679C15.1848 34.0673 14.947 34.4071 14.6243 34.6488C14.3015 34.8904 13.9109 35.0211 13.5094 35.0218V35.0218Z",
    fill: "#5F5FA7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_310_984",
    x: 5.74609,
    y: 27.1318,
    width: 122.505,
    height: 91.8015,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_310_984"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_310_984",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_984",
    x1: 124.72,
    y1: 114.011,
    x2: 124.217,
    y2: 95.6664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F95",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3F3F95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_310_984",
    x1: 124.964,
    y1: 98.8956,
    x2: 124.793,
    y2: 118.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F95",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3F3F95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_310_984",
    x1: 76.9762,
    y1: 42.597,
    x2: 42.0604,
    y2: 64.3252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F95",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3F3F95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_310_984",
    x1: 75.1863,
    y1: 45.1727,
    x2: 48.5027,
    y2: 61.7774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F95",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3F3F95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.9a139ca6d7c8a69b63f914e3eecf02f6.svg";
export { ForwardRef as ReactComponent };